<div [class]="containerClasses">
  <!-- Error message -->
  <div *ngIf="hasError && errorMessage" class="text-red-500 text-sm mb-2">
    {{ errorMessage }}
  </div>

  <!-- Image Preview -->
  <div *ngIf="selectedImage" class="relative group">
    <img
      [src]="selectedImage"
      alt="Preview"
      class="w-36 h-36 object-cover rounded-3xl border border-gray-200"
    />
    <button
      type="button"
      class="absolute top-2 right-2 bg-white rounded-full h-10 w-10 bg-opacity-50 hover:bg-opacity-70 text-black p-2 transition-all duration-200 opacity-0 group-hover:opacity-100"
      (click)="removeImage()"
      [disabled]="disabled"
    >
      <app-mb-icon type="close"></app-mb-icon>
    </button>
  </div>

  <!-- Upload Button -->
  <div *ngIf="!selectedImage" class="flex flex-col items-center justify-center">
    <button
      type="button"
      class="relative w-36 h-36 bg-opacity-10 bg-mbaza-upload-button border-1 border-dashed border-mbaza-gray-dark rounded-3xl hover:bg-opacity-20 transition-all duration-100 flex flex-col items-center justify-center group"
      (click)="triggerFileInput()"
      [disabled]="disabled"
      [class]="disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'"
    >
      <!-- Upload Icon -->
      <div
        class="w-8 h-8 rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-200"
      >
        <img [src]="icon" alt="Upload Icon" class="w-6 h-6" />
      </div>
    </button>
  </div>

  <!-- Hidden file input -->
  <input
    type="file"
    [accept]="accept"
    (change)="onFileSelect($event)"
    class="hidden"
    [disabled]="disabled"
  />
</div>
